import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "authenticationSlice",
    initialState: {
        token: localStorage.getItem("token"),
    },

    reducers: {
        LOGIN_SUCCESS: (state, action) => {
            return {
                ...state,
                token: localStorage.getItem("token"),
            };
        },

        LOGIN_ERROR: (state) => {
            return {
                ...state,
                token: "",
            };
        },

        UPDATE_PROFILE: (state, action) => {
            return {
                ...state,
                img: action?.payload?.img,
                user_name: action?.payload?.user_name,
            }
        },
    },
});

export const { LOGIN_SUCCESS, LOGIN_ERROR, UPDATE_PROFILE } = slice.actions;
export default slice.reducer;
